// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"h3-z","dimensionLabel":"i3-z","styleChooserControlWrapper":"j3-z","styleChooserControl":"k3-z","disabled":"l3-z","giftCard":"m3-z","styleChooserText":"n3-z"};